<script setup lang="ts"></script>

<template>
  <div class="modal-content">
    <!-- -my-2 py-2 -ml-2 pl-2 workaround to prevent ring to be clipped by overflow-auto -->
    <slot></slot>
  </div>
</template>
